import axios from 'axios';

// Las peticiones van al mismo servidor (Frontend Express actúa como proxy)
// La URL del Backend y la API Key solo existen en el servidor, no en el navegador
const api = axios.create({
    baseURL: '',
    headers: {
        'Content-Type': 'application/json'
    },
    withCredentials: true  // Enviar cookie de sesión en cada petición
});

// Interceptor para manejar errores
api.interceptors.response.use(
    (response) => response,
    (error) => {
        console.error('API Error:', error);

        // Redirigir al login si la sesión expiró o no es válida
        // Excluir /auth/* para no provocar un bucle al verificar la sesión al arrancar
        if (error.response?.status === 401 && !error.config?.url?.startsWith('/auth')) {
            window.location.href = '/login';
        }

        return Promise.reject(error);
    }
);

// Endpoints de autenticación (gestionados por el servidor Frontend)
export const authAPI = {
    login: (credentials) => api.post('/auth/login', credentials),
    logout: () => api.post('/auth/logout'),
    verifyToken: () => api.get('/auth/verify')
};

export const alumnosAPI = {
    getAll: () => api.get('/api/alumnos'),
    getById: (id) => api.get(`/api/alumnos/${id}`),
    getByYear: (year) => api.get(`/api/alumnos/curso/${year}`),
    create: (data) => api.post('/api/alumnos', data),
    update: (id, data) => api.put(`/api/alumnos/${id}`, data),
    delete: (id) => api.delete(`/api/alumnos/${id}`),
    // Matrícula anual (AlumnosCursos)
    getCursos: (id) => api.get(`/api/alumnos/${id}/cursos`),
    matricular: (id, curso) => api.post(`/api/alumnos/${id}/cursos`, { Curso: curso }),
    desmatricular: (id, curso) => api.delete(`/api/alumnos/${id}/cursos/${curso}`)
};

export const asignaturasAPI = {
    getAll: () => api.get('/api/asignaturas'),
    getById: (id) => api.get(`/api/asignaturas/${id}`),
    create: (data) => api.post('/api/asignaturas', data),
    update: (id, data) => api.put(`/api/asignaturas/${id}`, data),
    delete: (id) => api.delete(`/api/asignaturas/${id}`)
};

export const clasesAPI = {
    getAll: () => api.get('/api/clases'),
    getById: (id) => api.get(`/api/clases/${id}`),
    getByYear: (year) => api.get(`/api/clases/curso/${year}`),
    create: (data) => api.post('/api/clases', data),
    update: (id, data) => api.put(`/api/clases/${id}`, data),
    delete: (id) => api.delete(`/api/clases/${id}`)
};

export const instrumentosAPI = {
    getAll: () => api.get('/api/instrumentos'),
    getById: (id) => api.get(`/api/instrumentos/${id}`),
    create: (data) => api.post('/api/instrumentos', data),
    update: (id, data) => api.put(`/api/instrumentos/${id}`, data),
    delete: (id) => api.delete(`/api/instrumentos/${id}`)
};

export const profesoresAPI = {
    getAll: () => api.get('/api/profesores'),
    getById: (id) => api.get(`/api/profesores/${id}`),
    create: (data) => api.post('/api/profesores', data),
    update: (id, data) => api.put(`/api/profesores/${id}`, data),
    delete: (id) => api.delete(`/api/profesores/${id}`)
};

export const clasesAlumnosAPI = {
    getAll: () => api.get('/api/clases-alumnos'),
    getByClaseId: (classId) => api.get(`/api/clases-alumnos/clase/${classId}`),
    getByAlumnoId: (studentId) => api.get(`/api/clases-alumnos/alumno/${studentId}`),
    addAlumnoAClase: (classId, studentId) => api.post('/api/clases-alumnos', { claseId: classId, alumnoId: studentId }),
    removeAlumnoDeClase: (classId, studentId) => api.delete(`/api/clases-alumnos/${classId}/${studentId}`)
};
